/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { defineComponent, computed, toRefs, ref, watch, resolveComponent, openBlock, createBlock, normalizeClass } from 'vue';
import dayjs from 'dayjs';
import { c as commonjsGlobal } from '../_chunks/dep-28460046.js';
import { c as customParseFormat } from '../_chunks/dep-94c071a0.js';
import isArray from 'lodash/isArray';
import config from '../config.js';
import DateTimePickerProps from './props.js';
import { getMeaningColumn } from './shared.js';
import '../shared/index.js';
import { Picker } from '../picker/index.js';
import { useVModel } from '../shared/useVModel/index.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../shared/functions.js';
import '../shared/util.js';
import 'lodash/isNumber';
import '../shared/component.js';
import '../shared/constants.js';
import '../shared/render.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/camelCase';
import '../shared/render-tnode.js';
import '../shared/useToggle/index.js';
import '../shared/useCountDown/index.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import '@vueuse/core';
import '../shared/useCountDown/utils.js';
import '../shared/useDefault/index.js';
import '../shared/useChildSlots/index.js';
import '../shared/useTouch/index.js';
import '../shared/useScrollParent/index.js';
import '../shared/useExpose/index.js';
import '../shared/useTest/index.js';
import '@babel/runtime/helpers/defineProperty';
import '../shared/useClickAway/index.js';
import '../shared/useGesture/index.js';
import '@use-gesture/vanilla';
import '../shared/hover.js';
import 'lodash/kebabCase';
import '../picker/picker.js';
import 'lodash/isString';
import 'lodash/isBoolean';
import '../picker/props.js';
import '../picker/picker-item.js';
import '../picker/picker.class.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../shared/dom.js';
import 'lodash/isFunction';
import '../picker/cascade.js';
import './style/css.js';
import '../picker/type.js';

var weekday$1 = {exports: {}};

(function (module, exports) {
  !function (e, t) {
    "object" == 'object' && "undefined" != 'object' ? module.exports = t() : "function" == typeof undefined && undefined.amd ? undefined(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_weekday = t();
  }(commonjsGlobal, function () {
    "use strict";

    return function (e, t) {
      t.prototype.weekday = function (e) {
        var t = this.$locale().weekStart || 0,
          i = this.$W,
          n = (i < t ? i + 7 : i) - t;
        return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
      };
    };
  });
})(weekday$1, weekday$1.exports);
var weekday = weekday$1.exports;

dayjs.extend(weekday);
dayjs.extend(customParseFormat);
var prefix = config.prefix;
var name = "".concat(prefix, "-date-time-picker");
var precisionRankRecord = {
  year: 0,
  month: 1,
  date: 2,
  hour: 3,
  minute: 4,
  second: 5
};
var script = defineComponent({
  name: name,
  components: {
    TPicker: Picker
  },
  props: DateTimePickerProps,
  emits: ["change", "cancel", "confirm", "pick", "update:modelValue", "update:value"],
  setup: function setup(props) {
    var className = computed(function () {
      return ["".concat(name)];
    });
    var _toRefs = toRefs(props),
      value = _toRefs.value;
    var _useVModel = useVModel(value, ref(props.modelValue), props.defaultValue, props.onChange),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      innerValue = _useVModel2[0],
      setDateTimePickerValue = _useVModel2[1];
    var title = computed(function () {
      return props.title || "\u9009\u62E9\u65F6\u95F4";
    });
    var confirmButtonText = computed(function () {
      return props.confirmBtn || "\u786E\u5B9A";
    });
    var cancelButtonText = computed(function () {
      return props.cancelBtn || "\u53D6\u6D88";
    });
    var normalize = function normalize(val, defaultDay) {
      return val && dayjs(val).isValid() ? dayjs(val) : defaultDay;
    };
    var start = computed(function () {
      return normalize(props.start, dayjs().subtract(10, "year"));
    });
    var end = computed(function () {
      return normalize(props.end, dayjs().add(10, "year"));
    });
    var meaningColumn = computed(function () {
      return getMeaningColumn(props.mode);
    });
    var isTimeMode = computed(function () {
      return isArray(props.mode) && props.mode[0] == null && ["hour", "minute", "second"].includes(props.mode[1]);
    });
    var rationalize = function rationalize(val) {
      if (isTimeMode.value) return val;
      if (val.isBefore(start.value)) return start.value;
      if (val.isAfter(end.value)) return end.value;
      return val;
    };
    var calcDate = function calcDate(currentValue) {
      if (isTimeMode.value) {
        var dateStr = dayjs(start.value).format("YYYY-MM-DD");
        currentValue = "".concat(dateStr, " ").concat(currentValue);
      }
      return currentValue && dayjs(currentValue).isValid() ? rationalize(dayjs(currentValue)) : start.value;
    };
    var curDate = ref(calcDate(innerValue.value));
    var valueOfPicker = computed(function () {
      return meaningColumn.value.map(function (item) {
        return curDate.value[item]().toString();
      });
    });
    var columns = computed(function () {
      var ret = [];
      var getDate = function getDate(date) {
        return [date.year(), date.month() + 1, date.date(), date.hour(), date.minute(), date.second()];
      };
      var _getDate = getDate(curDate.value),
        _getDate2 = _slicedToArray(_getDate, 5),
        curYear = _getDate2[0],
        curMonth = _getDate2[1],
        curDay = _getDate2[2],
        curHour = _getDate2[3],
        curMinute = _getDate2[4];
      var _getDate3 = getDate(start.value),
        _getDate4 = _slicedToArray(_getDate3, 6),
        minYear = _getDate4[0],
        minMonth = _getDate4[1],
        minDay = _getDate4[2],
        minHour = _getDate4[3],
        minMinute = _getDate4[4],
        minSecond = _getDate4[5];
      var _getDate5 = getDate(end.value),
        _getDate6 = _slicedToArray(_getDate5, 6),
        maxYear = _getDate6[0],
        maxMonth = _getDate6[1],
        maxDay = _getDate6[2],
        maxHour = _getDate6[3],
        maxMinute = _getDate6[4],
        maxSecond = _getDate6[5];
      var isInMinYear = curYear === minYear;
      var isInMaxYear = curYear === maxYear;
      var isInMinMonth = isInMinYear && curMonth === minMonth;
      var isInMaxMonth = isInMaxYear && curMonth === maxMonth;
      var isInMinDay = isInMinMonth && curDay === minDay;
      var isInMaxDay = isInMaxMonth && curDay === maxDay;
      var isInMinHour = isInMinDay && curHour === minHour;
      var isInMaxHour = isInMaxDay && curHour === maxHour;
      var isInMinMinute = isInMinHour && curMinute === minMinute;
      var isInMaxMinute = isInMaxHour && curMinute === maxMinute;
      var typeUnit = {
        year: "\u5E74",
        month: "\u6708",
        date: "\u65E5",
        hour: "\u65F6",
        minute: "\u5206",
        second: "\u79D2"
      };
      var generateColumn = function generateColumn(start2, end2, type) {
        var arr = [];
        for (var i = start2; i <= end2; i++) {
          var value2 = i.toString();
          arr.push({
            label: props.renderLabel ? props.renderLabel(type, i) : "".concat(value2, " ").concat(typeUnit[type]),
            value: type === "month" ? "".concat(+value2 - 1) : value2
          });
        }
        ret.push(arr);
      };
      if (meaningColumn.value.includes("year")) {
        generateColumn(minYear, maxYear, "year");
      }
      if (meaningColumn.value.includes("month")) {
        var lower = isInMinYear ? minMonth : 1;
        var upper = isInMaxYear ? maxMonth : 12;
        generateColumn(lower, upper, "month");
      }
      if (meaningColumn.value.includes("date")) {
        var _lower = isInMinMonth ? minDay : 1;
        var _upper = isInMaxMonth ? maxDay : dayjs("".concat(curYear, "-").concat(curMonth)).daysInMonth();
        generateColumn(_lower, _upper, "date");
      }
      if (meaningColumn.value.includes("hour")) {
        var _lower2 = isInMinDay && !isTimeMode.value ? minHour : 0;
        var _upper2 = isInMaxDay && !isTimeMode.value ? maxHour : 23;
        generateColumn(_lower2, _upper2, "hour");
      }
      if (meaningColumn.value.includes("minute")) {
        var _lower3 = isInMinHour && !isTimeMode.value ? minMinute : 0;
        var _upper3 = isInMaxHour && !isTimeMode.value ? maxMinute : 59;
        generateColumn(_lower3, _upper3, "minute");
      }
      if (meaningColumn.value.includes("second")) {
        var _lower4 = isInMinMinute && !isTimeMode.value ? minSecond : 0;
        var _upper4 = isInMaxMinute && !isTimeMode.value ? maxSecond : 59;
        generateColumn(_lower4, _upper4, "second");
      }
      return ret;
    });
    var onConfirm = function onConfirm() {
      var _props$onConfirm;
      (_props$onConfirm = props.onConfirm) === null || _props$onConfirm === void 0 || _props$onConfirm.call(props, dayjs(curDate.value).format(props.format));
      setDateTimePickerValue(dayjs(curDate.value).format(props.format));
    };
    var onCancel = function onCancel(context) {
      var _props$onCancel;
      (_props$onCancel = props.onCancel) === null || _props$onCancel === void 0 || _props$onCancel.call(props, {
        e: context.e
      });
    };
    var onPick = function onPick(value2, context) {
      var _columns$value$column, _props$onPick;
      var column = context.column,
        index = context.index;
      var type = meaningColumn.value[column];
      var val = curDate.value.set(type, parseInt((_columns$value$column = columns.value[column][index]) === null || _columns$value$column === void 0 ? void 0 : _columns$value$column.value, 10));
      curDate.value = rationalize(val);
      (_props$onPick = props.onPick) === null || _props$onPick === void 0 || _props$onPick.call(props, rationalize(val).format(props.format));
    };
    watch(innerValue, function (val) {
      curDate.value = calcDate(val);
    });
    return {
      className: className,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      title: title,
      start: start,
      end: end,
      valueOfPicker: valueOfPicker,
      columns: columns,
      onConfirm: onConfirm,
      onCancel: onCancel,
      onPick: onPick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_t_picker = resolveComponent("t-picker");
  return openBlock(), createBlock(_component_t_picker, {
    class: normalizeClass(_ctx.className),
    value: _ctx.valueOfPicker,
    title: _ctx.title,
    "confirm-btn": _ctx.confirmButtonText,
    "cancel-btn": _ctx.cancelButtonText,
    columns: _ctx.columns,
    onConfirm: _ctx.onConfirm,
    onCancel: _ctx.onCancel,
    onPick: _ctx.onPick
  }, null, 8, ["class", "value", "title", "confirm-btn", "cancel-btn", "columns", "onConfirm", "onCancel", "onPick"]);
}

script.render = render;

export { script as default };
//# sourceMappingURL=date-time-picker.js.map
